import { render, staticRenderFns } from "./SetupListFilter.vue?vue&type=template&id=31c3a5ff&"
import script from "./SetupListFilter.vue?vue&type=script&lang=js&"
export * from "./SetupListFilter.vue?vue&type=script&lang=js&"
import style0 from "./SetupListFilter.vue?vue&type=style&index=0&id=31c3a5ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports